<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content" mat-dialog-content>
  <div class="subtitle1">
    抱歉，您的netflix不再可用。我们为您精心准备了以下补偿选项：
  </div>
  <div class="tabs">
    <div
      class="tab"
      (click)="changeIndex(1)"
      [ngClass]="{ active: index === 1 }"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 1"
        alt=""
      />
      转换为爆米花（全家桶会员）
    </div>
    <div
      class="tab"
      (click)="changeIndex(2)"
      [ngClass]="{ active: index === 2 }"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 2"
        alt=""
      />
      转化为借个号（钻石会员）
    </div>

    <!-- <div
      class="tab"
      (click)="changeIndex(3)"
      [ngClass]="{ active: index === 3 }"
    >
      等待账号修复（不推荐，修复时长20-30天）
    </div> -->
    <div
      class="tab"
      (click)="changeIndex(4)"
      [ngClass]="{ active: index === 4 }"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 4"
        alt=""
      />
      退款到环球巴士钱包
    </div>
    <div
      class="tab"
      (click)="changeIndex(5)"
      [ngClass]="{ active: index === 5 }"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 5"
        alt=""
      />
      冻结剩余时长
    </div>
  </div>
  <div class="choices" [ngClass]="{ active: index === 1 }">
    <div class="logo">
      <div class="imgs">
        <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
        <img src="../../../../assets/images/compensate/change.webp" alt="" />
        <img src="../../../../assets/images/compensate/popcorn.webp" alt="" />
      </div>
      <div>转换爆米花使用时长 =原方案订阅剩余时长x2</div>
    </div>
    <div class="detail1">您可以获得的权益</div>
    <div class="detail2">
      可同时使用：Netflix，Disney+，Prime Video，Crunchyroll五大平台 无清退风险
    </div>
    <div class="detail3">
      目前<span>仅支持 Windows 与 macOS 电脑端</span>，暂无观影记录
    </div>
  </div>
  <div class="choices" [ngClass]="{ active: index === 2 }">
    <div class="logo">
      <div class="imgs">
        <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
        <img src="../../../../assets/images/compensate/change.webp" alt="" />
        <span class="huiyuan">
          <img
            src="../../../../assets/images/compensate/huiyuan.webp"
            class="huiyuan"
            alt=""
          />钻石会员
        </span>
      </div>
      <div>当前剩余时间转为借个号钻石会员，再额外补偿2个月</div>
    </div>
    <div class="detail1">您可以获得的权益</div>
    <div class="detail2">
      可使用：<span>
        影视类：Netflix，Disney+，Max，Hulu，Nba，Prime video等
        AIGC类：ChatGPT，Adobe，Gamma，Grok等
      </span>
    </div>
    <div class="detail2">借号次数：<span>借期 3 天 | 每月 20 次</span></div>
    <div class="detail2">借号个数：3个账户</div>
    <div class="detail2">官方原版：租借的账户皆为官方原版，在官方平台使用</div>
  </div>

  <div class="choices" [ngClass]="{ active: index === 3 }">
    <div class="detail2">
      非常抱歉由于账号异常给您带来了不便，目前账号修复所需时长较长，不推荐选择此方案。感谢您的支持与理解。
    </div>
  </div>
  <div class="choices" [ngClass]="{ active: index === 4 }">
    <div class="detail2">
      您可选择将退款退至环球巴士钱包，余额可在续费或购买新订阅时<span>1:1抵扣</span>使用支持灵活组合支付，操作更加便捷高效。
    </div>
  </div>
  <div class="choices" [ngClass]="{ active: index === 5 }">
    <div class="logo">
      <div class="imgs">
        <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
        <img src="../../../../assets/images/compensate/change.webp" alt="" />
        <span class="huiyuan">
          <img
            class="huiyuan"
            src="../../../../assets/images/compensate/dongjie.png"
            alt=""
          />暂时冻结
        </span>
      </div>
      <div>当前剩余时间冻结，额外赠送爆米花(全家桶会员）使用</div>
    </div>
    <div class="detail2">冻结：3个月或6个月</div>
    <div class="detail2">冻结期间：赠送您爆米花全家桶会员使用</div>
    <div class="detail2">冻结期结束后：补发您奈账号恢复原剩余时长。</div>
    <div class="detail1">您可以获得的权益</div>
    <div class="detail2">
      可使用：<span>
        爆米花可同时使用：Netflix, Disney+, Prime Video, Crunchyroll, Max
        无清退风险
      </span>
    </div>
    <div class="detail3">
      目前<span>仅支持 Windows 与 macOS 电脑端</span>，暂无观影记录
    </div>
  </div>
</div>
<div class="button" [ngClass]="{ active: index === 1 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="changePopcorn()"
  >
    立即确认并转换
  </button>
</div>
<div class="button" [ngClass]="{ active: index === 2 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="changeJiegehao()"
  >
    立即确认并转换
  </button>
</div>
<div class="button" [ngClass]="{ active: index === 3 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="waitRepairTime()"
  >
    确认
  </button>
</div>
<div class="button" [ngClass]="{ active: index === 4 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="refund()"
  >
    确认退款
  </button>
</div>
<div class="button" [ngClass]="{ active: index === 5 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="freeze()"
  >
    立即确认并转换
  </button>
</div>
